import React from 'react'
import { Col } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import ReactTooltip from 'react-tooltip'

const statusQuality = {
  APPROVED_UNKNOWN:'/icons/approved-ca.svg',
  APPROVED_GREEN:'/icons/approved-ca.svg',
  APPROVED_YELLOW:'/icons/approved-cm.svg',
  APPROVED_RED:'/icons/approved-cm.svg',
  REJECTED_UNKNOWN: '/icons/refused.svg',
  PAUSED_UNKNOWN: '/icons/pause.svg',
  DISABLED_UNKNOWN: '/icons/stop.svg'
}

const QualityStatus = ({ templateId, status, quality, reason = 'NONE', error }) => {
  const validReason = reason !== 'NONE'
  const withError = !!(status !== 'APPROVED' && error)

  return (
    <>
      <Col className='p-0'>
        {quality && status ? (
          <div className={`contentQualityStatus ${withError ? 'ERROR' : `${status}_${quality}`}`}>
            {error ? (
              <img
                className='uploader-button__icon'
                src={`${getStaticImage('/icons/orange-brand/icon-warning-red.svg')}`}
                alt='Error'
              />
            ) : ['DRAFT', 'PENDING'].includes(status) ? (
              <i className='fa fa-check' />
            ) : (
              <img
                className='uploader-button__icon'
                src={`${getStaticImage(statusQuality[`${status}_${quality}`])}`}
                alt='Upload'
              />
            )}
            <div className='statusTemplate'>
              {
                withError
                  ? error?.text || I18n.t(`${status}_${quality}`)
                  : I18n.t(`${status}_${quality}`)
              }
            </div>
          </div>
        ) : null}
      </Col>
      {validReason ? (
        <Col>
          <figure
            className='reason-status-alert'
            data-tip={reason.replaceAll('_', ' ')}
            data-for={`${templateId}-template-status`}
          >
            <img
              src={getStaticImage('/icons/orange-brand/icon-warning-red.svg')}
              alt='App alert'
            />
          </figure>
          <ReactTooltip effect='solid' id={`${templateId}-template-status`} multiline={true} />
        </Col>
      ) : null}
    </>
  )
}

export default QualityStatus
